// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root__3SKwb","header":"Wrapper_header__3dKjT","content":"Wrapper_content__1aPWW","footer":"Wrapper_footer__1CMNj"};